import { UserEditComponent } from './../admin/user.editing/user.edit.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginpageComponent } from '../loginpage/loginpage.component';
import { HomepageComponent } from '../homepage/homepage.component';
import { FolderManagerComponent } from '../folder-manager/folder-manager.component';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component'
import { SystemProfileManagerComponent } from '../system-profile-manager/system-profile-manager.component';
import { TemplateManagerComponent } from '../template-manager/template-manager.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SoftwareUpgradeComponent } from "../software-upgrade/software-upgrade.component";
import { AuthGuard } from '../app/services/auth.guard';
import { AdminController } from 'src/admin/users.component';
import { LogsComponent } from 'src/logs/logs.component';
import { ErrorComponent } from 'src/shared/404/404.component';
import { MarketLocationEditComponent } from 'src/admin-market-location/market_location.editing/market_location.edit.component';
import { AdminMarketLocationController } from 'src/admin-market-location/market_location.component';
import { ReportGeneratorComponent } from 'src/report-generator/report-generator.component';
import { LoginpageSSOComponent } from 'src/loginpageSSO/loginpagesso.component';


const routes: Routes = [
  {
    path: '',
    component: HomepageComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  }, {
    path: 'login',
    component: LoginpageSSOComponent,
  }, {
    path: 'admin-login',
    component: LoginpageComponent,
  }, {
    path: 'login-sso',
    component: LoginpageSSOComponent,
  },
  {
    path: 'home',
    component: HomepageComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },

  {
    path: 'foldermanager',
    component: FolderManagerComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: 'systemprofile',
    component: SystemProfileManagerComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  }, {
    path: 'templatemanager',
    component: TemplateManagerComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  }, {
    path: 'packagemanager',
    component: FileUploaderComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  }, {
    path: 'softwareupdate',
    component: SoftwareUpgradeComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  //  {
  //   path: 'phonebook',
  //   component: PhonebookManagerComponent,
  //   canLoad: [AuthGuard],
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'admin',
    component: AdminController,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    children: [
      { path: 'new', component: UserEditComponent },
      { path: 'resetPassword', component: UserEditComponent },
      { path: 'edit', component: UserEditComponent }
    ]
  },
  {
    path: 'marketlocation',
    component: AdminMarketLocationController,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    children: [
      { path: 'new', component: MarketLocationEditComponent },
      { path: 'resetPassword', component: MarketLocationEditComponent },
      { path: 'edit', component: MarketLocationEditComponent }
    ]
  },
  {
    path: 'logs',
    component: LogsComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  }, {
    path: 'reportgenerator',
    component: ReportGeneratorComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    component: ErrorComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),


  ],
  exports: [
    RouterModule
  ],
  declarations: [],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
})
export class AppRoutingModule {
}
